module.exports = __webpack_public_path__ + "img/btn2.ebcf6345.png";